<template>
  <section class="faq-section bg-primary">
    <div class="container">
      <h2>{{ faq.title }}</h2>
      <p v-html="faq.description"></p>
      <div class="accordion" id="accordionFaq">
        <div
            class="accordion-item"
            v-for="(acc, index) in faq.dropdowns"
            :key="acc.id"
        >
          <h3 class="h2 accordion-header" :id="`heading-${index}`">
            <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#collapse${index}`"
                :aria-controls="`#collapse${index}`"
                aria-expanded="false"
                :class="{'btn-rotated': openAccordion[index]}"
                @click="toggleAccordion(index)"
            >
              {{ acc.title }}
            </button>
          </h3>
          <div
              :id="`#collapse${index}`"
              class="accordion-collapse collapse"
              :class="{'show': openAccordion[index]}"
              :aria-labelledby="`heading-${index}`"
              data-bs-parent="#accordionFaq"
          >
            <div class="accordion-body">
              <p v-html="acc.content"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    faq: {
      title: String,
      description: String,
      dropdowns: Array
    }
  },
  methods: {
    toggleAccordion(index) {
      if (this.currentOpen !== index) {
        this.openAccordion = {};
        this.openAccordion[index] = !this.openAccordion[index];
      } else {
        this.openAccordion[index] = !this.openAccordion[index];
      }

      this.currentOpen = index;
    },
  },
  data(){
    return {
      openAccordion: {},
      currentOpen: null,
    }
  },
}
</script>
